import { Product } from "@organizations/models";
import { createAction, props } from "@ngrx/store";

export const loadProducts = createAction("[Product/API] Load Products");

export const loadProductsSuccess = createAction(
  "[Product/API] Load Products Success",
  props<{ products: Product[] }>()
);

export const loadProductsFailure = createAction("[Product/API] Load Products Failure");
